// Mock data for Kesho Studio

export const founderData = [
  {
    id: 1,
    name: "Nhial Majok",
    role: "Founder & CEO",
    bio: "Nhial Majok has been active in the Bitcoin and broader crypto market since June 2013, applying deep market insight to guide early investments for friends, family, and private clients. With a proven track record across both bull and bear cycles, he has consistently focused on capital preservation during downturns while positioning portfolios to capture significant upside during market recoveries. A former IBM professional, Nhial combines strong technical expertise, disciplined investment strategy, and leadership experience with a deep interest in global macroeconomics and geopolitical trends. He leverages this perspective to build resilient fintech solutions and contribute meaningfully to the growth of Africa’s emerging digital finance ecosystem.",
    image:
      "https://nilecapital.co/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fmajok.4fa017a6.jpg&w=1920&q=75",
    linkedin: "#",
    twitter: "#",
  },
  {
    id: 2,
    name: "Abraham N. Wei",
    role: "Co-Founder & CTO",
    bio: "Abraham brings a background in communications and research from the humanitarian sector into the fintech industry, where he has spent the past four years contributing to crypto and fintech initiatives with various projects including Betzone and Nile Capital. His work spans strategic communications, marketing, and applied research across Kenya, South Sudan, and Uganda, helping organizations translate complex concepts into clear, actionable narratives that support growth, trust, and long-term value creation.",
    image:
      "https://nilecapital.co/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fabraham.06c69094.png&w=1920&q=75",
    linkedin: "#",
    twitter: "#",
  },
  {
    id: 3,
    name: "Collins Beigon",
    role: "Principal Software Engineer",
    bio: "Collins oversaw architecture, development, and scaling of Kesho Studio fintech applications including Pesabase and Nile Capital. He is currently leading the development of betzone, an online sports betting platform, encompassing, mobile, web and offline systems. He brings deep expertise in backend systems, payment and wallet integrations, real-time betting engines, APIs, and platform security. Works across the full development lifecycle, from system design and infrastructure planning to deployment and performance optimization, ensuring reliability, compliance, and scalability in high-volume environments.",
    image: "https://pesabase.com/assets/img/team/collins.png",
    linkedin: "#",
    twitter: "#",
  },
  {
    id: 4,
    name: "Ayuen Madyt",
    role: "Senior Software Engineer",
    bio: "Ayuen is a senior software engineer at Kesho Studio, leading the development of fintech applications and digital platforms. He brings strong technical experience, supports team growth, and helps deliver secure, scalable, and user-friendly products.",
    image: "/images/ayuen-madyt.jpeg",
    linkedin: "#",
    twitter: "#",
  },
];

export const portfolioData = [
  {
    id: 1,
    name: "Betzone",
    category: "Gaming & Betting",
    description:
      "Africa's premier crypto-powered betting platform, revolutionizing online gaming with instant blockchain transactions and enhanced user privacy.",
    image:
      "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=800&h=600&fit=crop",
    status: "Live",
    slug: "betzone",
    yearFounded: 2023,
    location: "Lagos, Nigeria",
    website: "https://betzone.africa",
  },
  {
    id: 4,
    name: "Nile Capital",
    category: "Investment & Finance",
    description:
      "DeFi investment platform connecting African ventures with global crypto investors, democratizing access to capital markets.",
    image:
      "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=800&h=600&fit=crop",
    status: "Live",
    slug: "nile-capital",
    yearFounded: 2022,
    location: "Cape Town, South Africa",
    website: "https://nilecapital.io",
  },
  {
    id: 2,
    name: "Sudoticket",
    category: "Ticketing & Events",
    description:
      "Decentralized ticketing solution leveraging NFTs to eliminate fraud and provide secure, transparent event access across Africa.",
    image:
      "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&h=600&fit=crop",
    status: "Live",
    slug: "sudoticket",
    yearFounded: 2025,
    location: "Nairobi, Kenya",
    website: "https://sudoticket.com",
  },
  {
    id: 3,
    name: "Timbersone",
    category: "Supply Chain",
    description:
      "Blockchain-based supply chain platform tracking timber resources, ensuring transparency and sustainability in African forestry management.",
    image:
      "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?w=800&h=600&fit=crop",
    status: "Development",
    slug: "timbersone",
    yearFounded: 2023,
    location: "Accra, Ghana",
    website: "https://timbersone.com",
  },
];

// Helper function to get company by slug
export const getCompanyBySlug = (slug) => {
  return portfolioData.find((company) => company.slug === slug);
};

// Helper function to get related companies (same category, excluding current)
export const getRelatedCompanies = (currentSlug, limit = 2) => {
  const currentCompany = getCompanyBySlug(currentSlug);
  if (!currentCompany) return [];

  return portfolioData
    .filter(
      (company) =>
        company.category === currentCompany.category &&
        company.slug !== currentSlug
    )
    .slice(0, limit);
};

export const contactInfo = {
  email: "hello@keshostudio.com",
  location: "Pan-African (Remote-First)",
  social: {
    twitter: "#",
    linkedin: "#",
    github: "#",
  },
};
